const USAGE_MASQUE = [
  "Nettoyez et séchez délicatement votre visage.",
  "Dépliez le masque et appliquez-le en épousant les contours du visage.",
  "Laissez poser 20 à 30 minutes, le temps d'un vrai moment pour vous.",
  "Retirez puis massez doucement l'excédent de sérum jusqu'à absorption.",
];

export const PRODUCTS = [
  {
    slug: "masque-bio-collagene",
    shortName: "Masque Bio-Collagène",
    name: "Masque Gel Hydratant au Bio-Collagène",
    tagline: "Un véritable bain d'hydratation pour une peau repulpée, lisse et lumineuse.",
    rating: 4.9,
    reviewsCount: 1240,
    badge: "Best-Seller Skincare 2026",
    images: ["/images/mask-hero.jpg", "/images/mask-gel.jpg", "/images/mask-hand.jpg", "/images/mask-variants.jpg"],
    textureImage: "/images/mask-gel.jpg",
    serumImage: "https://images.unsplash.com/photo-1655026392641-bf283a5f12d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBza2luY2FyZSUyMHdvbWFuJTIwZ2xvd2luZyUyMHNraW4lMjBiZWF1dHklMjBwcm9kdWN0fGVufDB8fHx8MTc4OTc0MDI0OHww&ixlib=rb-4.1.0&q=85",
    description: "Offrez à votre peau un véritable moment de soin. Enrichi en bio-collagène, acide hyaluronique et actifs hydratants, ce masque gel épouse parfaitement les contours du visage pour une hydratation intense et un teint lumineux.",
    benefits: [
      "Hydrate intensément la peau pendant 24h",
      "Améliore visiblement l'élasticité et la fermeté",
      "Laisse la peau plus douce, souple et rebondie",
      "Révèle un teint lumineux effet « glass skin »",
      "Procure une sensation de fraîcheur immédiate",
      "Testé sous contrôle dermatologique",
    ],
    usage: USAGE_MASQUE,
    inci: "Aqua, Glycerin, Hydrolyzed Collagen (Bio-Collagène), Sodium Hyaluronate (4 poids d'Acide Hyaluronique), Lactobacillus Ferment (Probiotiques), Niacinamide, Panthenol, Allantoin, Betaine, Carbomer, 1,2-Hexanediol, Parfum (sans allergènes).",
    variants: [
      { id: "relax_unitaire", label: "1 Masque", sublabel: "L'essentiel découverte", price: 10.9, perUnit: "10,90 € / masque" },
      { id: "relax_duo", label: "Duo Éclat", sublabel: "2 masques · -9%", price: 19.9, perUnit: "9,95 € / masque", popular: true },
      { id: "relax_coffret", label: "Coffret Cure", sublabel: "5 masques · -18%", price: 44.9, perUnit: "8,98 € / masque" },
    ],
    reviews: [
      { name: "Camille R.", city: "Paris", rating: 5, date: "il y a 2 jours", text: "Ma peau n'a jamais été aussi rebondie. Le gel est frais, le fini glowy… c'est devenu mon rituel du dimanche soir." },
      { name: "Inès M.", city: "Lyon", rating: 5, date: "il y a 1 semaine", text: "Résultat visible dès la première pose : teint lumineux, peau ultra douce. Le rapport qualité-prix est incroyable." },
      { name: "Sophie L.", city: "Bordeaux", rating: 4.5, date: "il y a 2 semaines", text: "Ma peau sensible l'adore : aucune réaction, juste du confort et de l'éclat. Je recommande les yeux fermés." },
    ],
  },
  {
    slug: "masque-hydro-cera",
    shortName: "Masque Hydra-Apaisant",
    name: "Masque Gel Hydra-Apaisant",
    tagline: "Le cocon apaisant des peaux sensibles, tiraillées ou réactives.",
    rating: 4.8,
    reviewsCount: 864,
    badge: "Spécial Peaux Sensibles",
    images: ["/images/cera-focus.jpg", "/images/range-full.jpg", "/images/mask-hand.jpg"],
    description: "Un masque gel enrichi en céramides et panthénol, eau glaciaire et acide hyaluronique bas poids moléculaire. Il apaise immédiatement, ressource la barrière cutanée et enveloppe la peau d'un cocon de fraîcheur réparateur.",
    benefits: [
      "Apaise immédiatement rougeurs et tiraillements",
      "Renforce la barrière cutanée grâce aux céramides",
      "Hydrate en profondeur avec l'acide hyaluronique bas poids",
      "Rafraîchit et calme les peaux échauffées",
      "Texture gel ultra-fraîche, fini confort durable",
      "Idéal après le soleil, le froid ou un actif exfoliant",
    ],
    usage: USAGE_MASQUE,
    inci: "Aqua, Glycerin, Ceramide NP, Panthenol, Sodium Hyaluronate, Glacier Water, Allantoin, Betaine, Dipotassium Glycyrrhizate, Carbomer, 1,2-Hexanediol.",
    variants: [
      { id: "cera_unitaire", label: "1 Masque", sublabel: "L'essentiel découverte", price: 10.9, perUnit: "10,90 € / masque" },
      { id: "cera_duo", label: "Duo Cocon", sublabel: "2 masques · -9%", price: 19.9, perUnit: "9,95 € / masque", popular: true },
    ],
    reviews: [
      { name: "Manon T.", city: "Nantes", rating: 5, date: "il y a 4 jours", text: "Après une semaine de grand froid, ma peau tiraillait partout. Une pose de ce masque et tout s'est calmé. Magique." },
      { name: "Léa D.", city: "Toulouse", rating: 4.5, date: "il y a 1 semaine", text: "Très apaisant, fini frais super agréable. J'aurais aimé un peu plus de sérum dans le sachet, mais le résultat est top." },
      { name: "Chloé B.", city: "Lille", rating: 5, date: "il y a 3 semaines", text: "Peau à rosacée légère ici : aucune réaction, rougeurs visiblement calmées. Enfin un masque pensé pour moi." },
    ],
  },
  {
    slug: "masque-vita-eclat",
    shortName: "Masque Vita Éclat",
    name: "Masque Gel Éclat Vita Niacinamide",
    tagline: "Le shot d'éclat anti-taches pour un teint uniforme et lumineux.",
    rating: 4.8,
    reviewsCount: 719,
    badge: "Effet Glow Immédiat",
    images: ["/images/vita-focus.jpg", "/images/mask-hand.jpg", "/images/mask-variants.jpg"],
    description: "Un concentré d'éclat en format masque gel : niacinamide, glutathion et eau d'ananas s'associent pour raviver les teints ternes, estomper l'apparence des taches et révéler une luminosité digne d'un filtre — sans filtre.",
    benefits: [
      "Ravive l'éclat des teints ternes et fatigués",
      "Atténue l'apparence des taches pigmentaires",
      "Uniformise le teint grâce à la niacinamide",
      "Le glutathion booste la luminosité naturelle",
      "L'eau d'ananas hydrate et adoucit le grain de peau",
      "Parfait en cure avant un événement",
    ],
    usage: USAGE_MASQUE,
    inci: "Aqua, Niacinamide, Glutathione, Ananas Sativus (Pineapple) Fruit Water, Glycerin, Sodium Hyaluronate, Panthenol, Betaine, Carbomer, 1,2-Hexanediol, Parfum (sans allergènes).",
    variants: [
      { id: "vita_unitaire", label: "1 Masque", sublabel: "L'essentiel découverte", price: 10.9, perUnit: "10,90 € / masque" },
      { id: "vita_duo", label: "Duo Glow", sublabel: "2 masques · -9%", price: 19.9, perUnit: "9,95 € / masque", popular: true },
    ],
    reviews: [
      { name: "Emma P.", city: "Marseille", rating: 5, date: "il y a 2 jours", text: "Posé la veille d'un mariage : teint frais et lumineux au réveil, maquillage parfait par-dessus. Le glow est réel." },
      { name: "Sarah K.", city: "Strasbourg", rating: 5, date: "il y a 1 semaine", text: "Mes taches post-été sont visiblement estompées après 3 poses. Enfin un masque éclat qui tient ses promesses." },
      { name: "Anaïs V.", city: "Nice", rating: 4.5, date: "il y a 2 semaines", text: "Odeur douce, gel frais, teint plus uniforme. Je rachète directement le duo pour être tranquille." },
    ],
  },
  {
    slug: "masque-nuit-collagene",
    shortName: "Masque de Nuit Collagène",
    name: "Masque-Crème de Nuit au Collagène — 75 ml",
    tagline: "Le soin peel-off qui travaille pendant votre sommeil : au réveil, une peau repulpée, lisse et lumineuse.",
    rating: 4.9,
    reviewsCount: 388,
    badge: "Nouveau · Star des Nuits",
    images: ["/images/night-packshot.jpg", "/images/night-apply.jpg", "/images/night-model.jpg", "/images/night-texture.jpg"],
    description: "Un masque-crème enveloppant au collagène à appliquer le soir en couche fine : il forme un film seconde peau qui diffuse ses actifs toute la nuit. Au réveil, on le pèle délicatement — la peau est nourrie, raffermie et éclatante. Pinceau applicateur silicone offert.",
    benefits: [
      "Hydrate et nourrit intensément pendant la nuit",
      "Effet liftant et raffermissant visible au réveil",
      "Lisse les ridules de déshydratation",
      "Resserre les pores et affine le grain de peau",
      "Peel-off doux : se retire sans tirer, sans résidu",
      "Pinceau applicateur silicone offert",
    ],
    usage: [
      "Le soir, sur peau propre, appliquez une couche fine et uniforme avec le pinceau silicone (évitez sourcils et racine des cheveux).",
      "Laissez sécher 15 à 20 minutes, puis partez dormir : le film travaille toute la nuit.",
      "Au réveil, retirez délicatement le film en le pelant, ou rincez à l'eau tiède.",
      "Utilisez 2 à 3 fois par semaine, ou en cure chaque soir pendant 7 jours.",
    ],
    inci: "Aqua, Hydrolyzed Collagen, Polyvinyl Alcohol, Glycerin, Niacinamide, Sodium Hyaluronate, Tocopherol (Vitamine E), Panthenol, Allantoin, Carbomer, 1,2-Hexanediol, Parfum (sans allergènes).",
    variants: [
      { id: "nuit_unitaire", label: "1 Tube · 75 ml", sublabel: "+ pinceau silicone offert", price: 14.9, perUnit: "14,90 € / tube" },
      { id: "nuit_duo", label: "Duo Nuit", sublabel: "2 tubes · -10%", price: 26.9, perUnit: "13,45 € / tube", popular: true },
    ],
    reviews: [
      { name: "Julie M.", city: "Paris", rating: 5, date: "il y a 3 jours", text: "Je l'applique le soir et au réveil ma peau est repulpée, comme après 12h de sommeil. Le peel-off du matin est devenu mon petit rituel préféré." },
      { name: "Nora H.", city: "Montpellier", rating: 4.5, date: "il y a 1 semaine", text: "Texture gel rosée très agréable, ne colle pas à l'oreiller une fois sec. Pores visiblement resserrés après deux semaines." },
      { name: "Élise F.", city: "Rennes", rating: 5, date: "il y a 2 semaines", text: "Le pinceau offert change tout : application uniforme, zéro gaspillage. Ma peau est lumineuse au réveil, même en plein hiver." },
    ],
  },
  {
    slug: "pack-rituel",
    shortName: "Pack Rituel Complet",
    name: "Pack Rituel Complet — 3 Masques Gel + Masque de Nuit",
    tagline: "Le rituel Relax au grand complet : les 3 masques gel iconiques et le masque de nuit collagène, réunis à prix doux.",
    rating: 5.0,
    reviewsCount: 96,
    badge: "Meilleure Offre · -16 %",
    images: ["/images/range-full.jpg", "/images/mask-hero.jpg", "/images/night-packshot.jpg", "/images/mask-hand.jpg"],
    description: "Tout le rituel Relax en une seule commande : le Masque Bio-Collagène pour repulper, le Masque Hydra-Apaisant pour apaiser, le Masque Vita Éclat pour illuminer, et le Masque-Crème de Nuit pour régénérer pendant le sommeil. Le cadeau parfait — pour soi ou pour une amie.",
    benefits: [
      "Le rituel complet en une seule commande",
      "Masque Bio-Collagène : hydratation et repulp intense",
      "Masque Hydra-Apaisant : apaise les peaux sensibles",
      "Masque Vita Éclat : glow et teint uniforme",
      "Masque de Nuit : régénération pendant le sommeil",
      "16 % d'économie + livraison offerte",
    ],
    usage: [
      "2 à 3 soirs par semaine : le masque gel adapté à votre peau du moment (20-30 min).",
      "Les autres soirs : le Masque-Crème de Nuit en couche fine avant le coucher.",
      "Avant un événement : Masque Vita Éclat pour le glow immédiat.",
      "Peau sensibilisée : Masque Hydra-Apaisant en SOS apaisant.",
    ],
    inci: "Voir la composition détaillée de chaque produit sur sa fiche dédiée.",
    variants: [
      { id: "pack_rituel", label: "Pack Rituel — 4 produits", sublabel: "Livraison offerte incluse", price: 39.9, perUnit: "soit 9,98 € / produit", compareAt: 47.6, popular: true },
    ],
    reviews: [
      { name: "Laura G.", city: "Lyon", rating: 5, date: "il y a 2 jours", text: "Le pack parfait pour découvrir toute la gamme : j'alterne les masques selon l'état de ma peau. Le masque de nuit est mon coup de cœur." },
      { name: "Marie C.", city: "Bordeaux", rating: 5, date: "il y a 1 semaine", text: "Offert à ma sœur puis racheté pour moi. Le rituel complet à ce prix, c'est donné — et le colis est très chic." },
      { name: "Ingrid S.", city: "Paris", rating: 4.5, date: "il y a 3 semaines", text: "Trois masques gel + le soin de nuit : ma peau n'a jamais été aussi régulière et lumineuse. Je recommande le pack les yeux fermés." },
    ],
  },
];

export const HERO_PRODUCT = PRODUCTS[0];

export const SHIPPING_OPTIONS = [
  { id: "standard", label: "Colissimo Standard", detail: "2-3 jours ouvrés", price: 3.9 },
  { id: "express", label: "Chronopost Express", detail: "Livré en 24h", price: 7.9 },
];

export const FREE_SHIPPING_THRESHOLD = 25;

export const formatPrice = (value) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(value);

export const productBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);

const SKU_INDEX = {};
PRODUCTS.forEach((p) =>
  p.variants.forEach((v) => {
    SKU_INDEX[v.id] = { ...v, productSlug: p.slug, productName: p.shortName, image: p.images[0] };
  })
);

export const skuById = (id) => SKU_INDEX[id];
